import { render, staticRenderFns } from "./AlertWizard.vue?vue&type=template&id=8b7276a2&scoped=true"
import script from "./AlertWizard.vue?vue&type=script&lang=js"
export * from "./AlertWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7276a2",
  null
  
)

export default component.exports